import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import SrilankaImage from '../components/srilanka.png';

function Year2017() {
    const navigate = useNavigate(); // Initialize the navigate function
  
    // Function to handle container clicks
    const handleContainerClick = (path) => {
      navigate(path); // Navigate to the specified path
    };

    const handleBackClick = () => {
      navigate('/'); // Navigate to the home page
    };
  
    return (
      <div className="year-page">
        <h1>2017 Photos</h1>
        <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back 
      </button>
        <div className="location-grid">
          {/* Sri Lanka Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/srilanka')} // Redirect to /srilanka
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${SrilankaImage})` }}
            ></div>
            <p className="location-name">Sri Lanka</p>
          </div>
        </div>
      </div>
    );
  }
  
  export default Year2017;